import { render, staticRenderFns } from "./TrackableBrandOverview.vue?vue&type=template&id=8208daf0&scoped=true"
import script from "./TrackableBrandOverview.vue?vue&type=script&lang=js"
export * from "./TrackableBrandOverview.vue?vue&type=script&lang=js"
import style0 from "./TrackableBrandOverview.vue?vue&type=style&index=0&id=8208daf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8208daf0",
  null
  
)

export default component.exports